import React from 'react';
import Image from 'next/image';

const bullets = [
  {
    title: 'We come to you — no drop-off needed',
    desc: 'Mobile service to your home, office, or anywhere in Orange County. You keep your schedule; we handle the rest.',
  },
  {
    title: 'Premium results, never rushed',
    desc: "Every vehicle gets our full attention. We don't stack bookings or cut corners to fit more jobs in a day.",
  },
  {
    title: "Trusted on the world\'s finest vehicles",
    desc: 'Ferrari, Lamborghini, McLaren, Porsche, Rolls-Royce, Bentley, BMW M, and Tesla — we know what\'s at stake.',
  },
  {
    title: 'The right chemistry for every surface',
    desc: 'Paint, wheels, trim, glass, leather, and interiors — each surface treated with the correct product and technique.',
  },
  {
    title: 'Zero shortcuts. Zero cross-contamination.',
    desc: 'Brand-new microfiber towels on every vehicle. Fresh products. A process built around protecting your investment.',
  },
];

export default function WhyChooseUs() {
  return (
    <section style={{ padding: '120px 0', background: 'var(--mamba-graphite)' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <div className="label-gold mb-4 reveal">
              <span style={{ width: '32px', height: '1px', background: 'var(--mamba-gold-light)', display: 'inline-block' }} />
              Why DA1MAMBA
            </div>
            <h2
              className="section-heading reveal reveal-delay-1"
              style={{ fontSize: 'clamp(30px, 3.5vw, 48px)', marginBottom: '16px' }}
            >
              The detail your car<br />
              <span
                style={{
                  background: 'linear-gradient(135deg, var(--mamba-purple-bright), var(--mamba-gold-light))',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                has been waiting for.
              </span>
            </h2>
            <p className="reveal reveal-delay-2" style={{ color: 'var(--gray-dim)', fontSize: '16px', lineHeight: '1.75', fontFamily: 'DM Sans, sans-serif', marginBottom: '48px', maxWidth: '480px' }}>
              DA1MAMBA brings dealership-level detailing directly to Newport Beach, Irvine, and all of Orange County — using brand-new microfiber towels, safe chemistry, and a process built around protecting your vehicle's value.
            </p>

            <div className="flex flex-col gap-6">
              {bullets?.map((b, i) => (
                <div
                  key={i}
                  className="reveal"
                  style={{ transitionDelay: `${0.1 + i * 0.08}s`, display: 'flex', gap: '16px', alignItems: 'flex-start' }}
                >
                  <div
                    style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: '2px',
                      background: 'rgba(107,33,168,0.15)',
                      border: '1px solid rgba(107,33,168,0.3)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      marginTop: '2px',
                    }}
                  >
                    <svg width="14" height="14" fill="none" stroke="var(--mamba-purple-bright)" strokeWidth="2.5" viewBox="0 0 24 24">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                  </div>
                  <div>
                    <div style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 700, fontSize: '15px', color: 'var(--white)', marginBottom: '4px' }}>
                      {b?.title}
                    </div>
                    <div style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '14px', color: 'var(--gray-dim)', lineHeight: '1.6' }}>
                      {b?.desc}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Image */}
          <div className="reveal reveal-delay-2">
            <div style={{ position: 'relative', aspectRatio: '4/5', overflow: 'hidden', border: '1px solid rgba(107,33,168,0.2)' }}>
              <Image
                src="https://da1mambadetailing.com/assets/314609221_166020389450136_2725712082903081790_n_1751758475934.jpg"
                alt="Rolls-Royce luxury vehicle receiving professional mobile detailing service by DA1MAMBA"
                fill
                className="object-cover"
                sizes="(max-width: 1024px) 100vw, 50vw"
              />
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(10,10,10,0.6) 0%, transparent 60%)' }} />
              {/* Vehicle types overlay */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '24px',
                  left: '24px',
                  right: '24px',
                  background: 'rgba(10,10,10,0.85)',
                  border: '1px solid rgba(107,33,168,0.25)',
                  padding: '20px 24px',
                  backdropFilter: 'blur(12px)',
                }}
              >
                <div className="label-gold mb-3" style={{ fontSize: '10px' }}>Vehicles We Service</div>
                <p style={{ color: 'var(--gray-dim)', fontSize: '13px', lineHeight: '1.7', fontFamily: 'DM Sans, sans-serif' }}>
                  Tesla · BMW · Mercedes · Ferrari · Lamborghini · Porsche · McLaren · Audi · Rolls-Royce · Bentley · Trucks · SUVs · Motorcycles · Boats
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
